import React from 'react'
import Icon from './Icon'
import { sendDataLayer } from '../../utils/functions'

function Accordeon({
  isOpen,
  onToggle,
  title,
  content,
  className
}) {
  const toggler = (e) => {
    if (e.target.closest('.mc-accordeon-container.active') && isOpen) {
      onToggle()
      return
    }

    onToggle()
    sendDataLayer({
      datalayer: {
        event: 'frequently_questions',
        question: title
      }, repeat: true
    })
  }

  return (
    <div className={`${className} mc-accordeon-container slow_ani ${isOpen ? 'active' : ''}`}>
      <div
        className="mc-accordeon-toggle slow_ani"
        onClick={toggler}
      >
        {title}
        <div className="mc-accordeon-toggle-icon">
          <Icon name="faq" />
        </div>
      </div>
      {isOpen &&
        <div className="mc-accordeon-content">
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </div>
      }
    </div>
  )
}

export default Accordeon